import { useState, useEffect, useRef } from "react";
import {
  currencyFormate,
  formatInputToCapitalization,
  getVoucherDate,
  removeCurrencyComma,
} from "../Date_Formate_Utilitiy/Index";
import {
  parseTallyQuantity,
  formatTallyQuantity,
  formatQuantityWithUnit,
  parseUnitString,
  calculateAltUnits,
  calculateBaseUnitsFromInput,
  calculateUnitsDivisor,
} from "../Date_Formate_Utilitiy/StockItemUtility";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../redux/actions/action-creator";
const FIELD_ORDER = [
  "item_name",
  "godown_location",
  "item_qty",
  "item_rate",
  "per_unit",
  "item_amt",
];
const FIELD_ORDER_EXPENSES = ["ledger_account", "ledger_amount"];
const FIELD_ORDER_PAYMENT_ALLOCATION = [
  "payment_ledger_account",
  "payment_ledger_amount",
];
const DROPDOWN_FIELDS = [
  "item_name",
  "godown_location",
  "per_unit",
  "ledger_account",
  "payment_ledger_account",
];
export const useSale = ({
  data,
  setData,
  validations,
  refs,
  inputRefs,
  dynamicInputRef,
  setNameInput,
  contra_account_ledger_list,
  setLastFocusedInput,
  dynamicInputRef_expenses,
  dynamicInputRef_payment_allocation,
  isView,
}) => {
  const dispatch = useDispatch();
  const [submitConfirm, setSubmitConfirm] = useState("");
  const { company_session } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);
  const { stock_item_data, godown_data, contra_ledger_data, unit_data } =
    useSelector((state) => state.common);

  // Check if any modal is open and prevent changes
  // Blocking modals that should prevent focus on voucher inputs
  const standardModals = [
    "ledgerCreate",
    "godownCreateVoucher",
    "stockItemCreate",
    "period",
    "changeMode",
    "configure",
    "voucherTypeNameSelect",
    "dispatchDetails",
    "orderDetails",
    "otherVoucher",
    "create_group_under",
    "create_under",
    "create_stock_cat",
    "create_stock_company",
    "create_unit",
  ];

  const isDOMModalOpen = !!(
    document.querySelector(".modal_link") ||
    document.querySelector(".modal_message")
  );
  const isAnyModalOpen =
    standardModals.some((modal) => modal_state?.[modal]) || isDOMModalOpen;
  const cleanString = (str) => str?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();
  const modalStateRef = useRef(modal_state);

  useEffect(() => {
    modalStateRef.current = modal_state;
  }, [modal_state]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape") {
        if (submitConfirm) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setSubmitConfirm("");
          return;
        }
        if (isAnyModalOpen) {
          return;
        }
        const activeModals = Object.keys(modalStateRef.current || {}).filter(
          (key) => modalStateRef.current[key],
        );

        // Dropdown modals are those NOT in the standard/blocking list
        const openDropdownModals = activeModals.filter(
          (modal) => !standardModals.includes(modal),
        );

        if (openDropdownModals?.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openDropdownModals.forEach((modal) => {
            dispatch(closeModal(modal));
          });
        } else {
          event.preventDefault();
          event.stopImmediatePropagation();
          document.activeElement?.blur();
          setSubmitConfirm("Quit");
        }
      }
    };
    window.addEventListener("keydown", handleKeyPress, true);
    return () => window.removeEventListener("keydown", handleKeyPress, true);
  }, [submitConfirm, isAnyModalOpen]);

  const handleItemUpdate = (e, id, field, value) => {
    if (isAnyModalOpen || submitConfirm || isView) {
      // added isView
      e.preventDefault();
      return;
    }
    switch (field) {
      case "item_name":
        const stockList = Array.isArray(stock_item_data) ? stock_item_data : [];
        const listToVerify = [{ name: "End of List" }, ...stockList];
        const value_ = listToVerify?.some((item) =>
          cleanString(item?.name)?.includes(cleanString(value)),
        );
        if (value_) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "godown_location":
        const godownList = Array.isArray(godown_data) ? godown_data : [];
        const godownListToVerify = [{ name: "Any" }, ...godownList];
        const value_godown_location = godownListToVerify?.some((item) =>
          cleanString(item?.name)?.includes(cleanString(value)),
        );
        if (value_godown_location) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "item_qty":
        itemAmountAccordingToQuantity(id, field, value, false);
        break;
      case "item_rate":
        const value_item_rate = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_item_rate) {
          itemAmountAccordingToQuantity(id, field, value, false);
        }
        break;
      case "per_unit":
        const perListToVerify = [
          { symbol: "Not Applicable" },
          ...(data?.data_item?.find((item) => item.id === id)?.item_units ||
            []),
        ];
        const value_per = perListToVerify?.some((item) =>
          cleanString(item?.symbol)?.includes(cleanString(value)),
        );
        if (value_per) {
          itemAmountAccordingToQuantity(id, field, value, false);
        }
        break;
      case "item_amt":
        const value_item_amt = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_item_amt) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
          handleTotalAmount(id, field, value);
        }
        break;
      case "ledger_account":
        const contraList = Array.isArray(contra_ledger_data)
          ? contra_ledger_data
          : [];
        const ledgerListToVerify = [
          { ledger_name: "End of List" },
          ...contraList,
        ];
        const value_ledger_account = ledgerListToVerify?.some((item) =>
          cleanString(item?.ledger_name)?.includes(cleanString(value)),
        );
        if (value_ledger_account) {
          setData((prevState) => ({
            ...prevState,
            sale_ledger_data: prevState.sale_ledger_data.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "ledger_amount":
        const value_ledger_amount = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_ledger_amount) {
          setData((prevState) => ({
            ...prevState,
            sale_ledger_data: prevState.sale_ledger_data.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
          handleTotalAmountExpLedger(id, field, value);
        }
        break;
      case "payment_ledger_account":
        const matchedLedger = contra_ledger_data?.find(
          (item) =>
            cleanString(item?.ledger_name).toLowerCase() ===
            cleanString(value).toLowerCase(),
        );
        setData((prevState) => ({
          ...prevState,
          payment_allocation: prevState.payment_allocation.map((item, i) => {
            if (item.id === id) {
              const updatedItem = {
                ...item,
                [field]: value,
                ledger_name: value,
                payment_ledger_account_id: matchedLedger
                  ? matchedLedger.id
                  : "",
              };
              return updatedItem;
            }
            return item;
          }),
        }));
        break;
      case "payment_ledger_amount":
        const value_payment_ledger_amount =
          /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_payment_ledger_amount) {
          // Restriction: Total payment allocation must be <= Total of (Items + Ledger accounts)
          const total_pa_limit = safeParseNumber(data.total_amount_item);
          const other_pa_total = (data.payment_allocation || []).reduce(
            (acc, row) => {
              if (row.id !== id)
                return acc + safeParseNumber(row.payment_ledger_amount);
              return acc;
            },
            0,
          );

          const new_val = safeParseNumber(value);
          if (other_pa_total + new_val > total_pa_limit) {
            const max_allowed = total_pa_limit - other_pa_total;
            value = max_allowed > 0 ? max_allowed.toString() : "0";
          }

          setData((prevState) => ({
            ...prevState,
            payment_allocation: prevState.payment_allocation.map((item, i) => {
              if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
          handleTotalAmountPaymentAllocation(id, field, value);
        }
        break;
    }
  };
  // ******---------------------------------for Item Input Fields---------------------------------
  const handleFallbackNavigation = (e, id, field, value) => {
    const navigate = () => {
      const ref =
        dynamicInputRef.current[id] || dynamicInputRef.current[String(id)];
      if (ref) {
        const currentFieldIndex = FIELD_ORDER.indexOf(field);
        const shouldSkipToTotal = !value && field === "item_qty";

        let nextFieldIndex = currentFieldIndex + 1;
        if (shouldSkipToTotal && field === "item_qty")
          nextFieldIndex = FIELD_ORDER.indexOf("item_amt");

        if (currentFieldIndex !== -1) {
          if (
            (value === "" || value === "End of List") &&
            field === "item_name"
          ) {
            // Clear "End of List" from the item field if it was selected
            if (value === "End of List") {
              setData((prev) => {
                const updatedItems = prev.data_item.map((item) =>
                  item.id === id
                    ? {
                      ...item,
                      item_name: "",
                      item_id: "",
                      item_qty: "",
                      item_rate: "",
                      item_amt: "",
                      per_unit: "",
                      unit_name: "",
                      alt_unit_name: "",
                      combination_of_units: "",
                    }
                    : item,
                );

                const totalAmount = updatedItems.reduce(
                  (acc, row) => acc + safeParseNumber(row.item_amt),
                  0,
                );
                const totalExpenses = (prev.sale_ledger_data || []).reduce(
                  (acc, row) => acc + safeParseNumber(row.ledger_amount),
                  0,
                );

                return {
                  ...prev,
                  data_item: updatedItems,
                  total_amount: totalAmount,
                  total_amount_item: totalAmount + totalExpenses,
                  total_amount_allocate_party: totalAmount + totalExpenses,
                };
              });
            }

            const allExpenseIds = Object.keys(dynamicInputRef_expenses.current)
              .filter((rid) => dynamicInputRef_expenses.current[rid])
              .sort(
                (a, b) =>
                  (parseInt(a.replace(/\D/g, "")) || 0) -
                  (parseInt(b.replace(/\D/g, "")) || 0),
              );

            if (allExpenseIds.length > 0) {
              const firstExpId = allExpenseIds[0];
              const ref =
                dynamicInputRef_expenses.current[firstExpId]?.[
                FIELD_ORDER_EXPENSES[0]
                ];
              if (ref) {
                setTimeout(() => {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }, 50);
                return;
              }
            } else {
              // If no expense rows exist, create one and focus it
              const newRowId = addRowExpLedger();
              setTimeout(() => {
                const ref =
                  dynamicInputRef_expenses.current[newRowId]?.[
                  FIELD_ORDER_EXPENSES[0]
                  ];
                if (ref) {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }
              }, 100);
              return;
            }

            // Fallback if no expenses can be focused
            const narrationRef = inputRefs?.narration?.current;
            setTimeout(() => {
              if (narrationRef) {
                narrationRef.focus();
                narrationRef.setSelectionRange(
                  0,
                  narrationRef.value?.length || 0,
                );
              }
            }, 50);
            return;
          }

          while (nextFieldIndex < FIELD_ORDER.length) {
            const nextField = FIELD_ORDER[nextFieldIndex];
            const nextRef = ref[nextField];
            if (nextRef) {
              nextRef.focus();
              nextRef.setSelectionRange(0, nextRef.value?.length || 0);
              return;
            }
            nextFieldIndex++;
          }
        }

        // If no next field in current row, handle next row
        if (nextFieldIndex >= FIELD_ORDER.length) {
          const allRowIds = Object.keys(dynamicInputRef.current)
            .filter((rid) => dynamicInputRef.current[rid])
            .sort((a, b) => (parseInt(a) || 0) - (parseInt(b) || 0));

          const currentRowIndex = allRowIds.indexOf(String(id));
          const nextRowId =
            currentRowIndex !== -1 && currentRowIndex < allRowIds.length - 1
              ? allRowIds[currentRowIndex + 1]
              : null;

          if (nextRowId && field === "item_amt") {
            const nextRowRef = dynamicInputRef.current[nextRowId];
            const firstFieldRef = nextRowRef?.[FIELD_ORDER[0]];
            if (firstFieldRef) {
              firstFieldRef.focus();
              firstFieldRef.setSelectionRange(
                0,
                firstFieldRef.value?.length || 0,
              );
              return;
            }
          } else if (field === "item_amt") {
            // NO next row, if current item is not empty, add a new row
            const currentRow = data.data_item.find(
              (i) => String(i.id) === String(id),
            );
            if (
              currentRow &&
              currentRow.item_name &&
              currentRow.item_name !== "End of List"
            ) {
              const newRowId = addRow();
              setTimeout(() => {
                const nextRowRef = dynamicInputRef.current[newRowId];
                const firstFieldRef = nextRowRef?.[FIELD_ORDER[0]];
                if (firstFieldRef) {
                  firstFieldRef.focus();
                  firstFieldRef.setSelectionRange(
                    0,
                    firstFieldRef.value?.length || 0,
                  );
                }
              }, 100);
              return;
            }

            // Fallback chain: Expenses -> Payment Allocation -> Narration
            const allExpenseIds = Object.keys(dynamicInputRef_expenses.current)
              .filter((rid) => dynamicInputRef_expenses.current[rid])
              .sort(
                (a, b) =>
                  (parseInt(a.replace(/\D/g, "")) || 0) -
                  (parseInt(b.replace(/\D/g, "")) || 0),
              );

            if (allExpenseIds.length > 0) {
              const firstExpId = allExpenseIds[0];
              const ref =
                dynamicInputRef_expenses.current[firstExpId]?.[
                FIELD_ORDER_EXPENSES[0]
                ];
              if (ref) {
                ref.focus();
                ref.setSelectionRange(0, ref.value?.length || 0);
                return;
              }
            }

            const allPaymentIds = Object.keys(
              dynamicInputRef_payment_allocation.current,
            )
              .filter((rid) => dynamicInputRef_payment_allocation.current[rid])
              .sort(
                (a, b) =>
                  (parseInt(a.replace(/\D/g, "")) || 0) -
                  (parseInt(b.replace(/\D/g, "")) || 0),
              );

            if (allPaymentIds.length > 0) {
              const firstPAId = allPaymentIds[0];
              const ref =
                dynamicInputRef_payment_allocation.current[firstPAId]?.[
                FIELD_ORDER_PAYMENT_ALLOCATION[0]
                ];
              if (ref) {
                ref.focus();
                ref.setSelectionRange(0, ref.value?.length || 0);
                return;
              }
            }

            const narr = inputRefs.narration?.current;
            if (narr) {
              narr.focus();
              narr.setSelectionRange(0, narr.value?.length || 0);
              return;
            }
          }
        }
      }
    };

    if (e === null) {
      // Dropdown selection - needs a delay for re-renders (especially when units become available)
      // Increased delay for item_name to ensure unit-dependent fields (qty, rate, etc.) are rendered
      const delay = field === "item_name" ? 350 : 100;
      if (value === "End of List" && field === "item_name") {
        navigate();
      } else {
        setTimeout(navigate, delay);
      }
    } else {
      // Key press - navigate immediately
      navigate();
    }
  };

  // Helper function to safely parse number from any format (string, number, formatted)
  const safeParseNumber = (value) => {
    if (value == null || value === "" || value === undefined) {
      return 0;
    }

    // If already a number, return it
    if (typeof value === "number") {
      return isNaN(value) ? 0 : value;
    }

    // If string, remove commas and parse
    if (typeof value === "string") {
      const cleaned = removeCurrencyComma(value);
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    }

    return 0;
  };

  const calculateLedgerState = ({ data, id, newValue }) => {
    const rows = [...data.data_item];
    const currentRow = rows.find((r) => r.id === id);
    if (!currentRow) return null;

    // const prevValue = safeParseNumber(currentRow.prev_value);
    const inputValue = safeParseNumber(newValue);
    // const ledgerId = currentRow.item_amt;

    // let accountBalance = safeParseNumber(data.account_ledger_balance);

    // STEP 1: Revert previous value (UPDATE / DELETE case)
    // if (prevValue > 0) {
    //     rows.forEach((row) => {
    //         if (row.item_amt === ledgerId) {
    //             const balance = safeParseNumber(row.particular_ledger_balance);
    //             row.particular_ledger_balance = currencyFormate(balance + prevValue);
    //         }
    //     });
    //     accountBalance -= prevValue;
    // }

    // STEP 2: Apply new value (CREATE / UPDATE)
    // if (inputValue > 0) {
    //     rows.forEach((row) => {
    //         if (row.particular_ledger_id === ledgerId) {
    //             const balance = safeParseNumber(row.particular_ledger_balance);
    //             row.particular_ledger_balance = currencyFormate(balance - inputValue);
    //         }
    //     });
    //     accountBalance += inputValue;
    // }

    // STEP 3: Update current row meta
    // rows.forEach((row) => {
    //     if (row.id === id) {
    //         row.prev_value = inputValue > 0 ? newValue : "";
    //     }
    // });

    // STEP 4: Recalculate total amount
    const totalAmount = rows.reduce((acc, row) => {
      const amount = row.id === id ? inputValue : safeParseNumber(row.item_amt);
      return acc + amount;
    }, 0);

    return {
      // updatedRows: rows,
      totalAmount,
      // accountLedgerBalance: currencyFormate(accountBalance),
    };
  };

  const getDecimalPlaces = (unitSymbol) => {
    if (!unitSymbol || unitSymbol === "Not Applicable" || !unit_data) return 0;

    const unitInfo = parseUnitString(unitSymbol);
    if (unitInfo && unitInfo.type === "Compound") {
      // For compound units, we follow the base unit's decimal places for the remainder
      const baseUnit = unit_data.find((u) => u.symbol === unitInfo.baseUnit);
      return baseUnit ? parseInt(baseUnit.no_decimal_places) || 0 : 0;
    }

    const unit = unit_data.find((u) => u.symbol === unitSymbol);
    return unit ? parseInt(unit.no_decimal_places) || 0 : 0;
  };

  const itemAmountAccordingToQuantity = (
    id,
    field,
    newValue,
    shouldFormatQty = false,
  ) => {
    setData((prev) => {
      const item = prev.data_item.find((item) => item.id === id);
      if (!item) return prev;

      // Create a temporary item object with the new value for calculation
      const updatedItemForCalc = { ...item, [field]: newValue };

      const unitInfo = parseUnitString(updatedItemForCalc.unit_name);
      const altUnitInfo = parseUnitString(updatedItemForCalc.alt_unit_name);
      const mainUnitFactor = unitInfo?.factor || 1;
      const isCompound = mainUnitFactor > 1;

      let totalBaseUnits = 0;
      if (field === "item_qty") {
        totalBaseUnits = calculateBaseUnitsFromInput(
          newValue,
          updatedItemForCalc,
        );
      } else {
        totalBaseUnits = calculateBaseUnitsFromInput(
          updatedItemForCalc.item_qty,
          updatedItemForCalc,
        );
      }
      const isRateEmpty =
        !updatedItemForCalc.item_rate ||
        String(updatedItemForCalc.item_rate).trim() === "";
      const itemRate = safeParseNumber(updatedItemForCalc.item_rate);
      const perUnit = updatedItemForCalc.per_unit || "";

      // Calculate divisor
      let divisor = calculateUnitsDivisor(
        updatedItemForCalc,
        unitInfo,
        altUnitInfo,
        perUnit,
      );

      let itemAmount = 0;
      if (isRateEmpty) {
        itemAmount = safeParseNumber(updatedItemForCalc.item_amt);
      } else {
        if (divisor !== 0 && isFinite(totalBaseUnits / divisor)) {
          itemAmount = (totalBaseUnits / divisor) * itemRate;
        }

        if (isNaN(itemAmount) || !isFinite(itemAmount)) {
          itemAmount = 0;
        }
      }

      // Calculate combination_of_units
      const altPrecision = getDecimalPlaces(updatedItemForCalc.alt_unit_name);
      const totalAltUnits = calculateAltUnits(
        totalBaseUnits,
        updatedItemForCalc,
      );

      let formattedAltQty = "";
      if (altUnitInfo && altUnitInfo.type === "Compound") {
        formattedAltQty = formatTallyQuantity(
          totalAltUnits,
          altUnitInfo.factor,
          altPrecision,
          altUnitInfo,
        );
      } else if (altUnitInfo) {
        formattedAltQty = formatTallyQuantity(
          totalAltUnits,
          1,
          altPrecision,
          altUnitInfo,
        );
      }

      const combination_of_units =
        updatedItemForCalc.alt_unit_name &&
          updatedItemForCalc.alt_unit_name !== "Not Applicable"
          ? `${formattedAltQty}`
          : "";

      let formattedQty = updatedItemForCalc.item_qty;
      if (shouldFormatQty && updatedItemForCalc.item_qty) {
        const quantityLabel =
          unitInfo?.mainUnit || updatedItemForCalc.unit_name || "";
        const precision = getDecimalPlaces(updatedItemForCalc.unit_name);
        formattedQty = formatQuantityWithUnit(
          totalBaseUnits,
          mainUnitFactor,
          quantityLabel,
          precision,
          unitInfo,
        );
      }

      const updatedDataItems = prev.data_item.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            [field]: newValue,
            item_qty: shouldFormatQty
              ? formattedQty
              : updatedItemForCalc.item_qty,
            item_amt: currencyFormate(itemAmount.toFixed(2)),
            combination_of_units: combination_of_units,
          };
        }
        return row;
      });

      const totalAmount = updatedDataItems.reduce((acc, row) => {
        return acc + safeParseNumber(row.item_amt);
      }, 0);

      // Add expenses to total_amount_item and total_amount_allocate_party
      const totalExpenses = (prev.sale_ledger_data || []).reduce((acc, row) => {
        return acc + safeParseNumber(row.ledger_amount);
      }, 0);

      return {
        ...prev,
        data_item: updatedDataItems,
        total_amount: totalAmount,
        total_amount_item: totalAmount + totalExpenses,
        total_amount_allocate_party: totalAmount + totalExpenses,
      };
    });
  };

  const handleTotalAmount = async (id, field, value) => {
    const result = calculateLedgerState({
      data,
      id,
      newValue: value,
    });

    if (!result) return;

    // Calculate total expenses to ensure grand totals are correct
    const totalExpenses = (data.sale_ledger_data || []).reduce((acc, row) => {
      return acc + safeParseNumber(row.ledger_amount);
    }, 0);

    setData((prev) => ({
      ...prev,
      total_amount: result.totalAmount,
      total_amount_item: result.totalAmount + totalExpenses,
      total_amount_allocate_party: result.totalAmount + totalExpenses,
    }));
  };

  const calculateRateFromAmount = (id, amountValue) => {
    setData((prev) => {
      const updatedDataItems = prev.data_item.map((item) => {
        if (item.id !== id) return item;

        const updatedItemForCalc = { ...item, item_amt: amountValue };
        const amount = safeParseNumber(amountValue);
        const totalBaseUnits = calculateBaseUnitsFromInput(
          updatedItemForCalc.item_qty,
          updatedItemForCalc,
        );
        const unitInfo = parseUnitString(updatedItemForCalc.unit_name);
        const altUnitInfo = parseUnitString(updatedItemForCalc.alt_unit_name);
        const perUnit = updatedItemForCalc.per_unit || "";
        const divisor = calculateUnitsDivisor(
          updatedItemForCalc,
          unitInfo,
          altUnitInfo,
          perUnit,
        );

        if (
          !updatedItemForCalc.item_qty ||
          divisor === 0 ||
          totalBaseUnits === 0
        ) {
          return item;
        }

        const rate = (amount * divisor) / totalBaseUnits;
        if (!isFinite(rate)) {
          return item;
        }

        return {
          ...item,
          item_rate: rate > 0 ? currencyFormate(rate.toFixed(2)) : "",
        };
      });

      return {
        ...prev,
        data_item: updatedDataItems,
      };
    });
  };
  // Handle dynamic inputs
  const handleDynamicFocus = (e, id, field, value) => {
    if (window.isRestoringVoucherFocus) {
      return;
    }
    if (isAnyModalOpen || submitConfirm || isView) {
      // added isView
      e.preventDefault();
      e.target.blur();
      return;
    }

    // Clean amount if focusing on a financial field --------------------------------
    const financialFields = [
      "item_qty",
      "item_rate",
      "item_amt",
      "ledger_amount",
      "particular_ledger_pay_amount",
      "payment_ledger_amount",
    ];
    if (financialFields.includes(field) && value) {
      const cleanVal = removeCurrencyComma(value);
      if (cleanVal !== value) {
        if (
          field === "item_qty" ||
          field === "item_rate" ||
          field === "item_amt"
        ) {
          setData((prev) => ({
            ...prev,
            data_item: prev.data_item.map((item) =>
              item.id === id ? { ...item, [field]: cleanVal } : item,
            ),
          }));
        } else if (field === "ledger_amount") {
          setData((prev) => ({
            ...prev,
            sale_ledger_data: prev.sale_ledger_data.map((item) =>
              item.id === id ? { ...item, [field]: cleanVal } : item,
            ),
          }));
        } else {
          setData((prev) => ({
            ...prev,
            data: prev.data.map((item) =>
              item.id === id ? { ...item, [field]: cleanVal } : item,
            ),
          }));
        }
      }
    }

    const ref =
      dynamicInputRef.current[id]?.[field] ||
      dynamicInputRef_expenses.current[id]?.[field] ||
      dynamicInputRef_payment_allocation.current[id]?.[field];

    if (ref) {
      setNameInput(ref);
      if (ref.setSelectionRange) {
        if (field === "item_amt") {
          setTimeout(() => {
            ref.setSelectionRange(0, ref.value?.length || 0);
          }, 0);
        } else {
          ref.setSelectionRange(0, ref.value?.length || 0);
        }
      }
    }
    if (field === "item_name" && !modal_state?.[`${field}${id}`]) {
      dispatch(openModal(`${field}${id}`));
    }
    if (field === "godown_location" && !modal_state?.[`${field}${id}`]) {
      dispatch(openModal(`${field}${id}`));
    }
    if (field === "per_unit" && !modal_state?.[`${field}${id}`]) {
      dispatch(openModal(`${field}${id}`));
    }
    if (field === "ledger_account" && !modal_state?.[`${field}${id}`]) {
      dispatch(openModal(`${field}${id}`));
    }
    if (field === "payment_ledger_account" && !modal_state?.[`${field}${id}`]) {
      dispatch(openModal(`${field}${id}`));
    }
  };

  const handleDynamicBlur = (e, id, field, value) => {
    const refKey = `${field}${id}`;
    if (field === "item_name") {
      if (modalStateRef.current?.[refKey]) {
        dispatch(closeModal(refKey));
      }
    }
    if (field === "godown_location") {
      if (modalStateRef.current?.[refKey]) {
        dispatch(closeModal(refKey));
      }
    }
    if (field === "per_unit") {
      if (modalStateRef.current?.[refKey]) {
        dispatch(closeModal(refKey));
      }
    }
    if (field === "ledger_account") {
      if (modalStateRef.current?.[refKey]) {
        dispatch(closeModal(refKey));
      }
    }
    if (field === "payment_ledger_account") {
      if (modalStateRef.current?.[refKey]) {
        dispatch(closeModal(refKey));
      }
    }

    // Calculations on Blur
    if (field === "item_qty" || field === "item_rate" || field === "per_unit") {
      itemAmountAccordingToQuantity(id, field, value, true);
    }
    if (field === "item_amt") {
      calculateRateFromAmount(id, value);
      handleTotalAmount(id, field, value);
    }
    if (field === "ledger_amount") {
      handleTotalAmountExpLedger(id, field, value);
    }
    if (field === "payment_ledger_amount") {
      handleTotalAmountPaymentAllocation(id, field, value);
    }
  };

  const addRow = () => {
    const next_id =
      data?.data_item?.length > 0
        ? `${Math.max(...data.data_item.map((item) => parseInt(item.id) || 0)) + 1}`
        : "1";

    setData((prevFormData) => {
      const newEntry = {
        id: next_id,
        item_name: "",
        item_id: "",
        godown_location: "",
        godown_location_id: "",
        item_qty: "",
        item_rate: "",
        per_unit: "",
        item_amt: "",
        item_alternate_unit: "",
        is_unit_available: false,
        where_unit_num: "",
        where_alternate_unit_num: "",
        main_unit_name: "",
        combination_of_units: "",
        check_open: false,
        total_nos_box: "",
        total_no_box_unit: "",
      };

      return {
        ...prevFormData,
        data_item: [...(prevFormData.data_item || []), newEntry],
      };
    });

    return next_id;
  };
  // ******---------------------------------for Ledger Input Fields Expenses---------------------------------
  const handleFallbackNavigationExpLedger = (e, id, field, value) => {
    const navigate = () => {
      const ref = dynamicInputRef_expenses.current[id];
      if (ref) {
        const currentFieldIndex = FIELD_ORDER_EXPENSES.indexOf(field);
        let nextFieldIndex = currentFieldIndex + 1;

        if (currentFieldIndex !== -1) {
          if (
            (value === "" || value === "End of List") &&
            field == "ledger_account"
          ) {
            if (value === "End of List") {
              setData((prev) => {
                const updatedExp = prev.sale_ledger_data.map((item) =>
                  item.id === id
                    ? {
                      ...item,
                      ledger_account: "",
                      ledger_account_id: "",
                      ledger_amount: "",
                    }
                    : item,
                );
                const totalExpenses = updatedExp.reduce(
                  (acc, row) => acc + safeParseNumber(row.ledger_amount),
                  0,
                );
                const totalAmount = (prev.data_item || []).reduce(
                  (acc, row) => acc + safeParseNumber(row.item_amt),
                  0,
                );

                return {
                  ...prev,
                  sale_ledger_data: updatedExp,
                  total_amount_item: totalAmount + totalExpenses,
                  total_amount_allocate_party: totalAmount + totalExpenses,
                };
              });
            }

            // Fallback chain: Payment Allocation -> Narration
            const allPaymentIds = Object.keys(
              dynamicInputRef_payment_allocation.current,
            )
              .filter((rid) => dynamicInputRef_payment_allocation.current[rid])
              .sort(
                (a, b) =>
                  (parseInt(a.replace(/\D/g, "")) || 0) -
                  (parseInt(b.replace(/\D/g, "")) || 0),
              );

            if (allPaymentIds.length > 0) {
              const firstPAId = allPaymentIds[0];
              const ref =
                dynamicInputRef_payment_allocation.current[firstPAId]?.[
                FIELD_ORDER_PAYMENT_ALLOCATION[0]
                ];
              if (ref) {
                setTimeout(() => {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }, 100);
                return;
              }
            } else {
              const newRowId = addRowPaymentAllocation();
              setTimeout(() => {
                const newRowRef =
                  dynamicInputRef_payment_allocation.current[newRowId];
                const firstFieldRef =
                  newRowRef?.[FIELD_ORDER_PAYMENT_ALLOCATION[0]];
                if (firstFieldRef) {
                  firstFieldRef.focus();
                  firstFieldRef.setSelectionRange(
                    0,
                    firstFieldRef.value?.length || 0,
                  );
                }
              }, 100);
              return;
            }
          }

          while (nextFieldIndex < FIELD_ORDER_EXPENSES.length) {
            const nextField = FIELD_ORDER_EXPENSES[nextFieldIndex];
            const nextRef = ref[nextField];
            if (nextRef) {
              nextRef.focus();
              nextRef.setSelectionRange(0, nextRef.value?.length || 0);
              return;
            }
            nextFieldIndex++;
          }
        }

        // Handle next row
        if (nextFieldIndex >= FIELD_ORDER_EXPENSES.length) {
          const allRowIds = Object.keys(dynamicInputRef_expenses.current).sort(
            (a, b) =>
              (parseInt(a.replace(/\D/g, "")) || 0) -
              (parseInt(b.replace(/\D/g, "")) || 0),
          );
          const currentRowIndex = allRowIds.indexOf(id);
          const nextRowId = allRowIds[currentRowIndex + 1];

          if (nextRowId) {
            const nextRowRef = dynamicInputRef_expenses.current[nextRowId];
            const firstFieldRef = nextRowRef?.[FIELD_ORDER_EXPENSES[0]];
            if (firstFieldRef) {
              firstFieldRef.focus();
              firstFieldRef.setSelectionRange(
                0,
                firstFieldRef.value?.length || 0,
              );
              return;
            }
          } else if (field === "ledger_amount") {
            const newRowId = addRowExpLedger();
            setTimeout(() => {
              const newRowRef = dynamicInputRef_expenses.current[newRowId];
              const firstFieldRef = newRowRef?.[FIELD_ORDER_EXPENSES[0]];
              if (firstFieldRef) {
                firstFieldRef.focus();
                firstFieldRef.setSelectionRange(
                  0,
                  firstFieldRef.value?.length || 0,
                );
              }
            }, 100);
          }
        }
      }
    };

    if (e === null) {
      setTimeout(navigate, 150);
    } else {
      navigate();
    }
  };

  const calculateLedgerStateExpLedger = ({ data, id, newValue }) => {
    const rows = [...data.sale_ledger_data];
    const currentRow = rows.find((r) => r.id === id);
    if (!currentRow) return null;

    // const prevValue = safeParseNumber(currentRow.prev_value);
    const inputValue = safeParseNumber(newValue);
    // const ledgerId = currentRow.particular_ledger_id;

    // let accountBalance = safeParseNumber(data.account_ledger_balance);

    // STEP 1: Revert previous value (UPDATE / DELETE case)
    // if (prevValue > 0) {
    //     rows.forEach((row) => {
    //         if (row.particular_ledger_id === ledgerId) {
    //             const balance = safeParseNumber(row.particular_ledger_balance);
    //             row.particular_ledger_balance = currencyFormate(balance + prevValue);
    //         }
    //     });
    //     accountBalance -= prevValue;
    // }

    // STEP 2: Apply new value (CREATE / UPDATE)
    // if (inputValue > 0) {
    //     rows.forEach((row) => {
    //         if (row.particular_ledger_id === ledgerId) {
    //             const balance = safeParseNumber(row.particular_ledger_balance);
    //             row.particular_ledger_balance = currencyFormate(balance - inputValue);
    //         }
    //     });
    //     accountBalance += inputValue;
    // }

    // STEP 3: Update current row meta
    // rows.forEach((row) => {
    //     if (row.id === id) {
    //         row.prev_value = inputValue > 0 ? newValue : "";
    //     }
    // });

    // STEP 4: Recalculate total amount
    const totalAmount = rows.reduce((acc, row) => {
      const amount =
        row.id === id ? inputValue : safeParseNumber(row.ledger_amount);
      return acc + amount;
    }, 0);

    return {
      // updatedRows: rows,
      totalAmount,
      // accountLedgerBalance: currencyFormate(accountBalance),
    };
  };

  const handleTotalAmountExpLedger = async (id, field, value) => {
    const result = calculateLedgerStateExpLedger({
      data,
      id,
      newValue: value,
    });

    if (!result) return;

    setData((prev) => ({
      ...prev,
      // data: result.updatedRows,
      total_amount_item: result.totalAmount + data.total_amount,
      total_amount_allocate_party: result.totalAmount + data.total_amount,
      // account_ledger_balance: result.accountLedgerBalance,
    }));
  };

  const addRowExpLedger = () => {
    const next_id =
      data?.sale_ledger_data?.length > 0
        ? `L${Math.max(...data.sale_ledger_data.map((item) => parseInt(item.id?.toString()?.replace("L", "")) || 0)) + 1}`
        : "L1";

    setData((prevFormData) => {
      const newEntry = {
        id: next_id,
        ledger_account: "",
        ledger_account_id: "",
        rate_percentage: "",
        ledger_amount: "",
        check: false,
      };

      return {
        ...prevFormData,
        sale_ledger_data: [...(prevFormData.sale_ledger_data || []), newEntry],
      };
    });

    return next_id;
  };
  // ******---------------------------------for Payment Allocation---------------------------------
  const handleFallbackNavigationPaymentAllocation = (e, id, field, value) => {
    const navigate = () => {
      const ref = dynamicInputRef_payment_allocation.current[id];
      if (ref) {
        const currentFieldIndex = FIELD_ORDER_PAYMENT_ALLOCATION.indexOf(field);
        let nextFieldIndex = currentFieldIndex + 1;

        if (currentFieldIndex !== -1) {
          if (
            (value === "" ||
              value === "End of List" ||
              value === "Not Applicable") &&
            field == "payment_ledger_account"
          ) {
            const nextRef = inputRefs?.narration?.current;
            setTimeout(() => {
              if (nextRef) {
                nextRef.focus();
                nextRef.setSelectionRange(0, nextRef.value?.length || 0);
              }
            }, 100);
            return;
          }

          while (nextFieldIndex < FIELD_ORDER_PAYMENT_ALLOCATION.length) {
            const nextField = FIELD_ORDER_PAYMENT_ALLOCATION[nextFieldIndex];
            const nextRef = ref[nextField];
            if (nextRef) {
              nextRef.focus();
              nextRef.setSelectionRange(0, nextRef.value?.length || 0);
              return;
            }
            nextFieldIndex++;
          }
        }

        // Handle next row
        if (nextFieldIndex >= FIELD_ORDER_PAYMENT_ALLOCATION.length) {
          const allRowIds = Object.keys(
            dynamicInputRef_payment_allocation.current,
          )
            .filter((rid) => dynamicInputRef_payment_allocation.current[rid])
            .sort(
              (a, b) =>
                (parseInt(a.replace(/\D/g, "")) || 0) -
                (parseInt(b.replace(/\D/g, "")) || 0),
            );

          const currentRowIndex = allRowIds.indexOf(id);
          const nextRowId = allRowIds[currentRowIndex + 1];

          if (nextRowId) {
            const nextRowRef =
              dynamicInputRef_payment_allocation.current[nextRowId];
            const firstFieldRef =
              nextRowRef?.[FIELD_ORDER_PAYMENT_ALLOCATION[0]];
            if (firstFieldRef) {
              firstFieldRef.focus();
              firstFieldRef.setSelectionRange(
                0,
                firstFieldRef.value?.length || 0,
              );
              return;
            }
          } else if (field === "payment_ledger_amount") {
            // Check if total is already matched
            const remaining = safeParseNumber(data.total_amount_allocate_party);
            if (remaining <= 0) {
              // Total matched, move to narration
              const nextRef = inputRefs?.narration?.current;
              setTimeout(() => {
                if (nextRef) {
                  nextRef.focus();
                  nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                }
              }, 100);
            } else {
              // Add a new row
              const newRowId = addRowPaymentAllocation();
              setTimeout(() => {
                const newRowRef =
                  dynamicInputRef_payment_allocation.current[newRowId];
                const firstFieldRef =
                  newRowRef?.[FIELD_ORDER_PAYMENT_ALLOCATION[0]];
                if (firstFieldRef) {
                  firstFieldRef.focus();
                  firstFieldRef.setSelectionRange(
                    0,
                    firstFieldRef.value?.length || 0,
                  );
                }
              }, 100);
            }
          }
        }
      }
    };

    if (e === null) {
      setTimeout(navigate, 150);
    } else {
      navigate();
    }
  };

  const calculateLedgerStatePaymentAllocation = ({ data, id, newValue }) => {
    const rows = [...data.payment_allocation];
    const currentRow = rows.find((r) => r.id === id);
    if (!currentRow) return null;

    const inputValue = safeParseNumber(newValue);

    // STEP 4: Recalculate total amount
    const totalAmount = rows.reduce((acc, row) => {
      const amount =
        row.id === id ? inputValue : safeParseNumber(row.payment_ledger_amount);
      return acc + amount;
    }, 0);

    return {
      totalAmount,
    };
  };

  const handleTotalAmountPaymentAllocation = async (id, field, value) => {
    const result = calculateLedgerStatePaymentAllocation({
      data,
      id,
      newValue: value,
    });

    if (!result) return;

    setData((prev) => ({
      ...prev,
      total_amount_allocate_party: data.total_amount_item - result.totalAmount,
    }));
  };

  const addRowPaymentAllocation = () => {
    const next_id =
      data?.payment_allocation?.length > 0
        ? `PA_${Math.max(...data.payment_allocation.map((item) => parseInt(item.id?.toString()?.replace("PA_", "")) || 0)) + 1}`
        : "PA_1";

    setData((prevFormData) => {
      const newEntry = {
        id: next_id,
        payment_ledger_account: "",
        payment_ledger_account_id: "",
        payment_ledger_amount: "",
      };

      return {
        ...prevFormData,
        payment_allocation: [
          ...(prevFormData.payment_allocation || []),
          newEntry,
        ],
      };
    });

    return next_id;
  };

  // for Static input fields ------------------------------------------------------------

  const handleChange = (e, index) => {
    if (isAnyModalOpen || submitConfirm || isView) {
      // added isView
      e.preventDefault();
      return;
    }
    const { name, value } = e.target;

    // Apply field-specific validations
    const validation = validations[name];
    if (validation) {
      const isValid = validation(value);
      if (isValid || value === "") {
        setData((prevData) => {
          const updatedData = { ...prevData };

          if (typeof index !== "number") {
            const updatedValue =
              name === "name" || name === "notes"
                ? formatInputToCapitalization(value)
                : value;
            updatedData[name] = updatedValue;
          } else if (typeof index === "number") {
            // Update array fields within `data_item`
            updatedData.data_item = updatedData.data_item.map((item, i) =>
              i === index ? { ...item, [name]: value } : item,
            );
          }

          return updatedData;
        });
      }
    } else {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDropdownClick = (name, value) => {
    let nextField = null;
    const fields = Object.keys(inputRefs);
    const currentIndex = fields.indexOf(name);
    nextField = fields[currentIndex + 1] || null;

    if (name === "dispatch_date") {
      const hasDispatchData =
        data?.delivery_note_no ||
        data?.dispatch_doc_no ||
        data?.dispatch_through ||
        data?.destination ||
        data?.carrier_name_agent ||
        data?.bill_of_loading ||
        value;

      if (!hasDispatchData) {
        setData((prevData) => ({
          ...prevData,
          dispatch_detail: "Not Available",
        }));
      }

      dispatch(closeModal("dispatch_detail_modal"));

      // Focus on order_detail field
      const nextRef = inputRefs.order_detail;
      setTimeout(() => {
        if (nextRef && nextRef.current) {
          nextRef.current.focus();
          if (nextRef.current.setSelectionRange) {
            nextRef.current.setSelectionRange(0, nextRef.current.value?.length || 0);
          }
        }
      }, 50);
      return;
    } else if (name === "term_of_delivery") {
      const hasOrderData =
        data?.order_no ||
        data?.mode_term_payment ||
        data?.other_reference ||
        value;

      if (!hasOrderData) {
        setData((prevData) => ({
          ...prevData,
          order_detail: "Not Available",
        }));
      }

      dispatch(closeModal("order_detail_modal"));

      // Focus on first item field instead of narration
      const firstRowId = data?.data_item?.[0]?.id;
      const nextRef = dynamicInputRef.current[firstRowId]?.item_name;
      setTimeout(() => {
        if (nextRef) {
          nextRef.focus();
          nextRef.setSelectionRange(0, nextRef.value?.length || 0);
        }
      }, 50);
      return;
    }
    if (name === "dispatch_detail" && value == "Available") {
      dispatch(openModal("dispatch_detail_modal"));
      setTimeout(() => {
        const firstModalRef = inputRefs?.delivery_note_no?.current;
        if (firstModalRef) {
          firstModalRef.focus();
          firstModalRef.setSelectionRange(0, firstModalRef.value?.length || 0);
        }
      }, 0);
      return;
    }
    if (name === "order_detail" && value == "Available") {
      dispatch(openModal("order_detail_modal"));
      setTimeout(() => {
        const firstModalRef = inputRefs?.order_no?.current;
        if (firstModalRef) {
          firstModalRef.focus();
          firstModalRef.setSelectionRange(0, firstModalRef.value?.length || 0);
        }
      }, 0);
      return;
    }

    if (name === "dispatch_detail" && value == "Not Available") {
      const nextRef = inputRefs.order_detail;
      setTimeout(() => {
        if (nextRef && nextRef.current) {
          nextRef.current.focus();
          nextRef.current.setSelectionRange(
            0,
            nextRef.current.value?.length || 0,
          );
        }
      }, 0);
    } else if (name === "order_detail" && value == "Not Available") {
      const firstRowId = data?.data_item?.[0]?.id;
      const nextRef = dynamicInputRef.current[firstRowId]?.item_name;
      setTimeout(() => {
        if (nextRef) {
          nextRef.focus();
          nextRef.setSelectionRange(0, nextRef.value?.length || 0);
        }
      }, 0);
    } else if (nextField && inputRefs[nextField]?.current) {
      setTimeout(() => {
        if (inputRefs[nextField]?.current) {
          inputRefs[nextField].current.focus();
          inputRefs[nextField].current.setSelectionRange(
            0,
            inputRefs[nextField].current.value.length,
          );
          setSubmitConfirm("");
        }
      }, 0);
    } else if (modal_state?.dispatch_detail_modal) {
      setTimeout(() => {
        if (nextField && inputRefs[nextField]?.current) {
          inputRefs[nextField].current.focus();
          inputRefs[nextField].current.setSelectionRange(
            0,
            inputRefs[nextField].current.value.length,
          );
          setSubmitConfirm("");
        }
      }, 500);
    } else if (name === "narration") {
      setSubmitConfirm("Accept");
      inputRefs[name]?.current?.blur();
    }
  };

  const handleFocus = (e, index, field) => {
    if (window.isRestoringVoucherFocus) {
      return;
    }
    if (isAnyModalOpen || submitConfirm || isView) {
      // added isView
      e.preventDefault();
      e.target.blur();
      return;
    }

    const { name } = e.target;
    const ref = inputRefs[name];
    if (ref) {
      setNameInput(ref);
      setLastFocusedInput && setLastFocusedInput(ref.current);
      ref?.current?.setSelectionRange(0, ref?.current?.value?.length);
    }
    if (name === "party_bill_to" && !modal_state?.party_bill_to) {
      dispatch(openModal(name));
    }
    if (name === "party_ship_to" && !modal_state?.party_ship_to) {
      dispatch(openModal(name));
    }
    if (
      name === "sale_purchase_ledger_account" &&
      !modal_state?.sale_purchase_ledger_account
    ) {
      dispatch(openModal(name));
    }
    if (name === "location" && !modal_state?.location) {
      dispatch(openModal(name));
    }
    if (name === "dispatch_detail" && !modal_state?.dispatch_detail) {
      dispatch(openModal(name));
    }
    if (name === "order_detail" && !modal_state?.order_detail) {
      dispatch(openModal(name));
    }
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "party_bill_to") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "party_ship_to") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "sale_purchase_ledger_account") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "location") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "dispatch_detail") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "order_detail") {
      if (modalStateRef.current?.[name]) dispatch(closeModal(name));
    }
    if (name === "create_date" && value) {
      const dateResult = getVoucherDate(
        value,
        company_session,
        data?.create_date,
      );
      if (dateResult && dateResult.formattedDateString) {
        setData((prevData) => ({
          ...prevData,
          create_date: dateResult.formattedDateString,
          day_name: dateResult.day_show,
        }));
      }
    }
  };

  const handleKeyDown = (e, id, field) => {
    if (submitConfirm || isView) {
      // block keys in View mode
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (
      isAnyModalOpen &&
      (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp")
    ) {
      return;
    }
    const { name } = e.target;
    if (e.key === "Space") {
      if (e.target.selectionStart === 1) {
        e.preventDefault();
        setData({ ...data, [name]: "" });
        return;
      }
    }
    if (e.key === "Enter") {
      e.preventDefault();
      const { value } = e.target;

      if (id) {
        // Dynamic field Enter handling
        let section = "item";
        if (
          id.toString().startsWith("L") ||
          FIELD_ORDER_EXPENSES.includes(field)
        )
          section = "expenses";
        else if (
          id.toString().startsWith("PA_") ||
          id.toString().startsWith("P") ||
          FIELD_ORDER_PAYMENT_ALLOCATION.includes(field)
        )
          section = "payment_allocation";

        let index;
        if (section === "expenses")
          index = data?.sale_ledger_data?.findIndex((item) => item.id === id);
        else if (section === "payment_allocation")
          index = data?.payment_allocation?.findIndex((item) => item.id === id);
        else index = data?.data_item?.findIndex((item) => item.id === id);

        if (field === "item_amt") {
          calculateRateFromAmount(id, value);
        }
        if (DROPDOWN_FIELDS.includes(field)) {
          handleDropdownDynamicClick(field, value, id, section);
        } else {
          if (section === "expenses") {
            handleFallbackNavigationExpLedger(e, id, field, value);
          } else if (section === "payment_allocation") {
            handleFallbackNavigationPaymentAllocation(e, id, field, value);
          } else {
            handleFallbackNavigation(e, id, field, value);
          }
        }
      } else {
        // Static field Enter handling
        if (name === "create_date" && value) {
          const dateResult = getVoucherDate(
            value,
            company_session,
            data?.create_date,
          );
          if (dateResult && dateResult.formattedDateString) {
            setData((prevData) => ({
              ...prevData,
              create_date: dateResult.formattedDateString,
              day_name: dateResult.day_show,
            }));
          }
        }
        handleDropdownClick(name, value);
      }
      return;
    }

    if (e.key === "Tab") {
      e.preventDefault();
      e.stopPropagation();

      if (field === "item_amt") {
        calculateRateFromAmount(id, e.target.value);
      }

      const allItemIds = Object.keys(dynamicInputRef.current)
        .filter((rid) => dynamicInputRef.current[rid])
        .sort((a, b) => (parseInt(a) || 0) - (parseInt(b) || 0));

      const allExpenseIds = Object.keys(dynamicInputRef_expenses.current)
        .filter((rid) => dynamicInputRef_expenses.current[rid])
        .sort(
          (a, b) =>
            (parseInt(a.replace(/\D/g, "")) || 0) -
            (parseInt(b.replace(/\D/g, "")) || 0),
        );

      const allPaymentIds = Object.keys(
        dynamicInputRef_payment_allocation.current,
      )
        .filter((rid) => dynamicInputRef_payment_allocation.current[rid])
        .sort(
          (a, b) =>
            (parseInt(a.replace(/\D/g, "")) || 0) -
            (parseInt(b.replace(/\D/g, "")) || 0),
        );

      if (e.shiftKey) {
        // SHIFT + TAB (Backward)

        const focusPreviousDynamicRow = (currentSection, currentId) => {
          const hierarchy = [
            {
              section: "payment_allocation",
              ids: allPaymentIds,
              refs: dynamicInputRef_payment_allocation,
              order: FIELD_ORDER_PAYMENT_ALLOCATION,
            },
            {
              section: "expenses",
              ids: allExpenseIds,
              refs: dynamicInputRef_expenses,
              order: FIELD_ORDER_EXPENSES,
            },
            {
              section: "item",
              ids: allItemIds,
              refs: dynamicInputRef,
              order: FIELD_ORDER,
            },
          ];

          let startIndex = hierarchy.findIndex(
            (h) => h.section === currentSection,
          );
          if (startIndex === -1) startIndex = 0;

          for (let h = startIndex; h < hierarchy.length; h++) {
            const block = hierarchy[h];
            let startIdIndex = block.ids.length - 1;

            if (block.section === currentSection && currentId) {
              startIdIndex = block.ids.indexOf(currentId) - 1;
            }

            for (let i = startIdIndex; i >= 0; i--) {
              const rowId = block.ids[i];
              for (let j = block.order.length - 1; j >= 0; j--) {
                const f = block.order[j];
                const targetRef = block.refs.current[rowId]?.[f];
                if (targetRef && !targetRef.disabled) {
                  targetRef.focus();
                  targetRef.setSelectionRange(0, targetRef.value?.length || 0);
                  return true;
                }
              }
            }
          }
          return false;
        };

        const focusLastStaticField = () => {
          const fields = Object.keys(inputRefs).filter(
            (f) => inputRefs[f]?.current && !inputRefs[f].current.disabled,
          );
          const staticBeforeDynamics = [...fields]
            .reverse()
            .find((f) => f !== "narration");
          if (
            staticBeforeDynamics &&
            inputRefs[staticBeforeDynamics]?.current
          ) {
            const ref = inputRefs[staticBeforeDynamics].current;
            ref.focus();
            ref.setSelectionRange(0, ref.value?.length || 0);
          }
        };

        if (id && field) {
          const section =
            id.toString().startsWith("PA_") ||
              id.toString().startsWith("P") ||
              FIELD_ORDER_PAYMENT_ALLOCATION.includes(field)
              ? "payment_allocation"
              : id.toString().startsWith("L") ||
                FIELD_ORDER_EXPENSES.includes(field)
                ? "expenses"
                : "item";

          let blockOrder, blockRefs;
          if (section === "payment_allocation") {
            blockOrder = FIELD_ORDER_PAYMENT_ALLOCATION;
            blockRefs = dynamicInputRef_payment_allocation;
          } else if (section === "expenses") {
            blockOrder = FIELD_ORDER_EXPENSES;
            blockRefs = dynamicInputRef_expenses;
          } else {
            blockOrder = FIELD_ORDER;
            blockRefs = dynamicInputRef;
          }

          const currentFieldIndex = blockOrder.indexOf(field);
          let prevFieldIndex = currentFieldIndex - 1;
          let focused = false;

          // 1. Try previous fields in the same row
          while (prevFieldIndex >= 0) {
            const prevField = blockOrder[prevFieldIndex];
            const targetRef = blockRefs.current[id]?.[prevField];
            if (targetRef && !targetRef.disabled) {
              targetRef.focus();
              targetRef.setSelectionRange(0, targetRef.value?.length || 0);
              focused = true;
              break;
            }
            prevFieldIndex--;
          }

          // 2. Try previous dynamic rows/sections
          if (!focused) {
            focused = focusPreviousDynamicRow(section, id);
          }

          // 3. Fallback to static field before dynamic area
          if (!focused) {
            focusLastStaticField();
          }
        } else {
          const fields = Object.keys(inputRefs).filter(
            (f) => inputRefs[f]?.current && !inputRefs[f].current.disabled,
          );
          const currentIndex = fields.indexOf(name);

          if (name === "narration") {
            if (!focusPreviousDynamicRow(null, null)) {
              // If no dynamic fields, go to previous static field
              if (currentIndex > 0) {
                const prevField = fields[currentIndex - 1];
                const ref = inputRefs[prevField].current;
                if (ref && !ref.disabled) {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }
              }
            }
          } else if (currentIndex > 0) {
            const prevField = fields[currentIndex - 1];
            const ref = inputRefs[prevField].current;
            if (ref && !ref.disabled) {
              ref.focus();
              ref.setSelectionRange(0, ref.value?.length || 0);
            }
          }
        }
      } else {
        // TAB (Forward)
        if (id && field) {
          const section =
            id.toString().startsWith("PA_") ||
              id.toString().startsWith("P") ||
              FIELD_ORDER_PAYMENT_ALLOCATION.includes(field)
              ? "payment_allocation"
              : id.toString().startsWith("L") ||
                FIELD_ORDER_EXPENSES.includes(field)
                ? "expenses"
                : "item";

          if (section === "payment_allocation") {
            // Payment Allocation
            const currentFieldIndex =
              FIELD_ORDER_PAYMENT_ALLOCATION.indexOf(field);
            if (currentFieldIndex < FIELD_ORDER_PAYMENT_ALLOCATION.length - 1) {
              const nextField =
                FIELD_ORDER_PAYMENT_ALLOCATION[currentFieldIndex + 1];
              const ref =
                dynamicInputRef_payment_allocation.current[id]?.[nextField];
              if (ref) {
                ref.focus();
                ref.setSelectionRange(0, ref.value?.length || 0);
              }
            } else {
              const currentIndex = allPaymentIds.indexOf(id);
              if (currentIndex < allPaymentIds.length - 1) {
                const nextId = allPaymentIds[currentIndex + 1];
                const ref =
                  dynamicInputRef_payment_allocation.current[nextId]?.[
                  FIELD_ORDER_PAYMENT_ALLOCATION[0]
                  ];
                if (ref) {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }
              } else {
                if (field === "payment_ledger_amount") {
                  // Check if total is already matched
                  const remaining = safeParseNumber(
                    data.total_amount_allocate_party,
                  );
                  if (remaining <= 0) {
                    if (inputRefs.narration?.current) {
                      inputRefs.narration.current.focus();
                      inputRefs.narration.current.setSelectionRange(
                        0,
                        inputRefs.narration.current.value?.length || 0,
                      );
                    }
                  } else {
                    // Add a new row
                    const newRowId = addRowPaymentAllocation();
                    setTimeout(() => {
                      const newRowRef =
                        dynamicInputRef_payment_allocation.current[newRowId];
                      const firstFieldRef =
                        newRowRef?.[FIELD_ORDER_PAYMENT_ALLOCATION[0]];
                      if (firstFieldRef) {
                        firstFieldRef.focus();
                        firstFieldRef.setSelectionRange(
                          0,
                          firstFieldRef.value?.length || 0,
                        );
                      }
                    }, 100);
                  }
                } else {
                  if (inputRefs.narration?.current) {
                    inputRefs.narration.current.focus();
                    inputRefs.narration.current.setSelectionRange(
                      0,
                      inputRefs.narration.current.value?.length || 0,
                    );
                  }
                }
              }
            }
          } else if (section === "expenses") {
            // Expenses
            const currentFieldIndex = FIELD_ORDER_EXPENSES.indexOf(field);
            if (currentFieldIndex < FIELD_ORDER_EXPENSES.length - 1) {
              const nextField = FIELD_ORDER_EXPENSES[currentFieldIndex + 1];
              const ref = dynamicInputRef_expenses.current[id]?.[nextField];
              if (ref) {
                ref.focus();
                ref.setSelectionRange(0, ref.value?.length || 0);
              }
            } else {
              const currentIndex = allExpenseIds.indexOf(id);
              if (currentIndex < allExpenseIds.length - 1) {
                const nextId = allExpenseIds[currentIndex + 1];
                const ref =
                  dynamicInputRef_expenses.current[nextId]?.[
                  FIELD_ORDER_EXPENSES[0]
                  ];
                if (ref) {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }
              } else if (field === "ledger_amount") {
                // Add a new expense row if we're on the last field of the last row
                const newRowId = addRowExpLedger();
                setTimeout(() => {
                  const nextRowRef = dynamicInputRef_expenses.current[newRowId];
                  const firstFieldRef = nextRowRef?.[FIELD_ORDER_EXPENSES[0]];
                  if (firstFieldRef) {
                    firstFieldRef.focus();
                    firstFieldRef.setSelectionRange(
                      0,
                      firstFieldRef.value?.length || 0,
                    );
                  }
                }, 100);
              } else {
                const firstPAId = allPaymentIds[0];
                const ref =
                  dynamicInputRef_payment_allocation.current[firstPAId]?.[
                  FIELD_ORDER_PAYMENT_ALLOCATION[0]
                  ];
                if (ref) {
                  ref.focus();
                  ref.setSelectionRange(0, ref.value?.length || 0);
                }
              }
            }
          } else {
            // Items
            const currentFieldIndex = FIELD_ORDER.indexOf(field);
            let nextFieldIndex = currentFieldIndex + 1;

            while (nextFieldIndex < FIELD_ORDER.length) {
              const nextField = FIELD_ORDER[nextFieldIndex];
              const ref = dynamicInputRef.current[id]?.[nextField];
              if (ref) {
                ref.focus();
                ref.setSelectionRange(0, ref.value?.length || 0);
                return;
              }
              nextFieldIndex++;
            }

            if (nextFieldIndex >= FIELD_ORDER.length && field === "item_amt") {
              const allRowIds = Object.keys(dynamicInputRef.current)
                .filter((rid) => dynamicInputRef.current[rid])
                .sort((a, b) => (parseInt(a) || 0) - (parseInt(b) || 0));

              const currentRowIndex = allRowIds.indexOf(String(id));
              const nextRowId =
                currentRowIndex !== -1 && currentRowIndex < allRowIds.length - 1
                  ? allRowIds[currentRowIndex + 1]
                  : null;

              if (nextRowId) {
                const nextRowRef = dynamicInputRef.current[nextRowId];
                const firstFieldRef = nextRowRef?.[FIELD_ORDER[0]];
                if (firstFieldRef) {
                  firstFieldRef.focus();
                  firstFieldRef.setSelectionRange(
                    0,
                    firstFieldRef.value?.length || 0,
                  );
                }
              } else {
                // Fallback chain: Expenses -> Payment -> Narration
                const allExpenseIds = Object.keys(
                  dynamicInputRef_expenses.current,
                )
                  .filter((rid) => dynamicInputRef_expenses.current[rid])
                  .sort(
                    (a, b) =>
                      (parseInt(a.replace(/\D/g, "")) || 0) -
                      (parseInt(b.replace(/\D/g, "")) || 0),
                  );

                const expRef =
                  allExpenseIds.length > 0
                    ? dynamicInputRef_expenses.current[allExpenseIds[0]]?.[
                    FIELD_ORDER_EXPENSES[0]
                    ]
                    : null;

                if (expRef) {
                  expRef.focus();
                  expRef.setSelectionRange(0, expRef.value?.length || 0);
                } else {
                  const allPaymentIds = Object.keys(
                    dynamicInputRef_payment_allocation.current,
                  )
                    .filter(
                      (rid) => dynamicInputRef_payment_allocation.current[rid],
                    )
                    .sort(
                      (a, b) =>
                        (parseInt(a.replace(/\D/g, "")) || 0) -
                        (parseInt(b.replace(/\D/g, "")) || 0),
                    );

                  const paRef =
                    allPaymentIds.length > 0
                      ? dynamicInputRef_payment_allocation.current[
                      allPaymentIds[0]
                      ]?.[FIELD_ORDER_PAYMENT_ALLOCATION[0]]
                      : null;

                  if (paRef) {
                    paRef.focus();
                    paRef.setSelectionRange(0, paRef.value?.length || 0);
                  } else if (inputRefs.narration?.current) {
                    inputRefs.narration.current.focus();
                    inputRefs.narration.current.setSelectionRange(
                      0,
                      inputRefs.narration.current.value?.length || 0,
                    );
                  }
                }
              }
            }
          }
        } else {
          if (name === "order_detail") {
            const firstId = allItemIds[0] || 1;
            const ref = dynamicInputRef.current[firstId]?.[FIELD_ORDER[0]];
            if (ref) {
              ref.focus();
              ref.setSelectionRange(0, ref.value?.length || 0);
            }
          } else {
            const fields = Object.keys(inputRefs).filter(
              (f) => inputRefs[f]?.current && !inputRefs[f].current.disabled,
            );
            const currentIndex = fields.indexOf(name);
            if (currentIndex < fields.length - 1) {
              const nextField = fields[currentIndex + 1];
              const ref = inputRefs[nextField].current;
              ref.focus();
              ref.setSelectionRange(0, ref.value?.length || 0);
            }
          }
        }
      }
    }
  };

  const handleDropdownDynamicClick = (field, value, index, section) => {
    let id;
    const ledger = (contra_ledger_data || [])?.find(
      (l) => l.ledger_name === value,
    );

    if (section === "expenses") {
      const foundItem =
        data?.sale_ledger_data?.find((i) => String(i.id) === String(index)) ||
        data?.sale_ledger_data?.[index];
      id = foundItem?.id;
      if (id) {
        setData((prev) => ({
          ...prev,
          sale_ledger_data: prev.sale_ledger_data.map((item) =>
            String(item.id) === String(id)
              ? {
                ...item,
                [field]: value,
                ledger_id: ledger
                  ? ledger.id || ledger.ledger_id || ""
                  : item.ledger_id,
                ledger_balance: ledger
                  ? ledger.opening_balance || ""
                  : item.ledger_balance,
              }
              : item,
          ),
        }));
        dispatch(closeModal(`${field}${id}`));
        setTimeout(() => {
          handleFallbackNavigationExpLedger(null, id, field, value);
        }, 50);
      }
    } else if (section === "payment_allocation") {
      const foundItem =
        data?.payment_allocation?.find((i) => String(i.id) === String(index)) ||
        data?.payment_allocation?.[index];
      id = foundItem?.id;
      if (id) {
        setData((prev) => ({
          ...prev,
          payment_allocation: prev.payment_allocation.map((item) =>
            String(item.id) === String(id)
              ? {
                ...item,
                [field]: value,
                ledger_name: value, // Sync both
                payment_ledger_account_id: ledger
                  ? ledger.id || ledger.ledger_id || ""
                  : item.payment_ledger_account_id,
                payment_ledger_balance: ledger
                  ? ledger.opening_balance || ""
                  : item.payment_ledger_balance,
              }
              : item,
          ),
        }));
        dispatch(closeModal(`${field}${id}`));
        setTimeout(() => {
          handleFallbackNavigationPaymentAllocation(null, id, field, value);
        }, 50);
      }
    } else {
      const foundItem =
        data?.data_item?.find((i) => String(i.id) === String(index)) ||
        data?.data_item?.[index];
      id = foundItem?.id;
      if (id) {
        dispatch(closeModal(`${field}${id}`));
        // Trigger calculation if item-related field changes via dropdown
        if (
          field === "item_qty" ||
          field === "item_rate" ||
          field === "per_unit" ||
          field === "item_name"
        ) {
          itemAmountAccordingToQuantity(id, field, value);
        }
        setTimeout(() => {
          handleFallbackNavigation(null, id, field, value);
        }, 50);
      }
    }
  };

  return {
    handleChange,
    handleFocus,
    handleBlur,
    submitConfirm,
    setSubmitConfirm,
    handleItemUpdate,
    handleDynamicFocus,
    handleDynamicBlur,
    handleDropdownClick,
    handleDropdownDynamicClick,
    handleKeyDown,
  };
};
